<template>
<div style="background:#fff">
    <!-- <headerComponent/> -->
    <div class="pageContainer">
        <!-- <carousel :perPage="1" :autoplay="true" :loop="true" style="height:540px">  
            <slide v-for="image in images" :key="image">  
                <img :src="require(`${image}`)" alt="carousel image">  
            </slide>  
        </carousel>   -->
         <img :src="curImg.src" alt="" srcset="" style="width:100%;" class="animate__animated animate__slideInLeft">
    </div>
    <div class="containerOne" style="position:relative;width:100%;padding-bottom:40px;margin:45px 0 0 0">
      <div style="width:1300px;margin:0 auto">
        <!-- <img src="@/views/solution/images/group02.png" alt="" srcset="" style="width:100%;padding:30px 0 0px 0;display:block;margin-bottom:60px;"> -->
        <!-- 公共组建开始 -->
        <module-tit :title="solutionInfo?.cateInfo?.sub_name" :subTitle="solutionInfo?.cateInfo?.name"/>
        <!-- 公共组件结束 -->
        <div :class="index%2==0 ? 'one animate__animated animate__fadeInLeft':'one animate__animated animate__fadeInRight'" :style="index%2===0?'float:left;position:relative;cursor:pointer':'float:right;position:relative;cursor:pointer'"  v-animate-onscroll="'animate__animated animate__fadeInLeft'" v-for="(item,index) in solutionInfo.data" :key="index"  @click="handleDetail(item)" @mouseenter="currentImageIndex = index" @mouseleave="currentImageIndex = null">
          <div class="clearfix image-item" style="display: inline-block;width: 94%" > 
                <img :src="item.thumb" alt="" srcset="" style="width:100%" :class="{ zoomed: currentImageIndex === index }">
          </div>
          <div class="footWords">
            <span style="font-size:24px;font-weight:700">{{item.title}}</span>
            <span style="font-size:16px;padding:0 0 0 20px">{{item.cate_name}}</span>
            <span style="position:absolute;right:40px">查看解决方案 > </span>
          </div>
        </div>
        <div class="clearBoth"></div>
        <!-- <div class="one animate__animated animate__fadeInRight" style="float:right;text-align:right;position:relative"  v-animate-onscroll="'animate__animated animate__fadeInRight'">
          <div class="clearfix" style="display: inline-block;width: 94%" > 
            
              <img src="@/views/solution/images/item02.png" alt="" srcset="" style="width:100%">
           
          </div>
          <div class="footWords" @click="handleDetail">
            <span style="font-size:24px;font-weight:700;position:absolute;left:40px">交通运输</span>
            <span style="font-size:16px;position:absolute;left:180px">TRANSPORTATION</span>
            <span>查看解决方案 > </span>
          </div>
        </div>

        <div class="clearBoth"></div>
        <div class="one" style="float:left;position:relative" v-animate-onscroll="'animate__animated animate__fadeInLeft'">
          <div class="clearfix" style="display: inline-block;width: 94%" > 
            
          <img src="@/views/solution/images/item03.png" alt="" srcset="" style="width:100%">
           </div>
          <div class="footWords" @click="handleDetail">
            <span style="font-size:24px;font-weight:700">工业设备</span>
            <span style="font-size:16px;padding:0 0 0 20px">INDUSTRIAL EQUIPMENT</span>
            <span style="position:absolute;right:40px">查看解决方案 > </span>
          </div>
        </div>
        
        <div class="one" style="float:right;text-align:right;position:relative" v-animate-onscroll="'animate__animated animate__fadeInRight'">
          <div class="clearfix" style="display: inline-block;width: 94%" > 
            
          <img src="@/views/solution/images/item04.png" alt="" srcset="" style="width:100%">
         </div>
          <div class="footWords" @click="handleDetail">
            <span style="font-size:24px;font-weight:700;position:absolute;left:40px">家居生活</span>
            <span style="font-size:16px;position:absolute;left:180px">HOME LIFE</span>
            <span>查看解决方案 > </span>
          </div>
        </div> -->
      </div>
    </div>
    <!-- <footerComponent/> -->
</div>
</template>
<script>
import moduleTit from '@/components/moduleTit'
import { getList,cate } from '@/api/index.js'
export default {
  name: 'App',
   components:{
    moduleTit
  },
  data() {  
    return {  
      solutionInfo:{},
      curImg:{},
      currentImageIndex: null // 当前鼠标覆盖的图片索引
    };  
  }, 
  mounted() {
    this.$nextTick(()=>{
      this.getInitEvent()
      this.cateEvent()
    })
  },
  methods:{
    filterItemsByPath(path,arr) {
      let _arr = []
      let newArr = []
      _arr = arr
      newArr =  _arr.filter(item => item.path === path);
      if (newArr.length > 0) {
        return newArr[0]; // 只取第一个匹配的对象
      } else {
        return {}; // 如果没有匹配的对象，返回空对象
      }
  },
    cateEvent() {
      cate().then((res)=>{
          this.curImg = this.filterItemsByPath('/#/solution',res.data).banner[0]
      })
    },
    getInitEvent() {
      let _id = this.$route.query.id
      let _obj = {cateId:_id}
      getList(_obj).then((res)=>{
        this.solutionInfo = res.data
      })
    },
    handleDetail(item) {
       this.$router.push({path: '/solutionDetail',query:{id:item.id,model_type:item.model_type}})
    }
  }
}
</script>
<style lang="scss" scoped>
.containerOne{
  .one{
    width:50%
  }
}
.footWords{
  padding:20px 0;
  line-height: 30px;
}
.footWords:hover{
  cursor: pointer;
}
.clearBoth {
  clear:both
}

.image-item {
  overflow: hidden; /* 确保放大的图片不会超出容器 */
}

.image-item img {
  width: 100%; /* 图片填满容器 */
  transition: transform 0.3s ease; /* 平滑过渡效果 */
}

.image-item img.zoomed {
  transform: scale(1.2); /* 放大比例，这里设置为1.2倍 */
}
</style>
